// takes array of thresholds, array of data, 
// returns array count of data within each threshold
export function histogram (data, thresholds) {
  let result = new Array (thresholds.length).fill(0);
  thresholds.sort((a,b) => a-b);
  const gramable = filterNaN (data)
  gramable.forEach (item => {
    const bin = thresholds.findIndex((element) => element > (isNaN(item) ? 0 : item))
    const hist = bin >= 0 ? Math.max(0, bin - 1) : result.length -1;
    result[hist]++;
  })
  if (gramable.length !== data.length) {
    result.unshift(data.length - gramable.length)
  }
  return result;  
}

function filterNaN (arrData) {
  return arrData.filter (item => !isNaN(item))
}